import { internalAddressWith, type RouteHandlingOfType } from './internalAddress';

/**
 * I-2453 (`tasks/2026-11-02-shell-bridge-split.md`, S2): the route table (`@featit/shared/shell-route-table`,
 * about 6 KB) is read on a click, never while a first screen draws, so the launch does not load it.
 * `InternalLinkClicks` loads it once the browser is idle after the launch, or at the first press,
 * whichever is sooner; inside the app shell the launch awaits it before the first render (`index.tsx`),
 * so a link there is never a document load. Until it is here a click is the browser's own: the address
 * loads as a document, which is correct, only slower.
 */
let routeOf: RouteHandlingOfType | null = null;
let loading: Promise<void> | null = null;

export function loadInternalAddresses(): Promise<void> {
  loading ??= import('@featit/shared/shell-route-table').then(
    (module) => {
      routeOf = module.shellRouteOf;
    },
    (error: unknown) => {
      // A failed chunk is asked for again by the next caller rather than remembered.
      loading = null;
      throw error;
    },
  );
  return loading;
}

/**
 * `href` as an address of this app or `null` (`internalAddressWith`); `undefined` while the route
 * table is not loaded, so the caller leaves the click to the browser.
 */
export function loadedInternalAddressOf(
  href: string | null | undefined,
  origin: string = window.location.origin,
): string | null | undefined {
  return routeOf ? internalAddressWith(routeOf, href, origin) : undefined;
}
